export default __webpack_public_path__ + "static/media/intro3-small.3e478b67.mp4";